import React from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import moment from 'moment';
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

const ReviewRejectedEvents = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

    const qrSubjectList = useSelector((state) => state.qrSubjectList);



  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    setFilteredData(qrSubjectList)
  }, [dispatch, qrSubjectList]);


  function exportToExcel() {

    let excelArray = [];
    filteredData.forEach((i) => {

    //   switch (i.status) {
    //     case EVENT_STATUS_WAITING_FOR_REVIEW:
    //       i.status = "Waiting for review";
    //       break;
    //     case EVENT_STATUS_IN_PROGRESS:
    //       i.status = "In progress";
    //       break;
    //     case EVENT_STATUS_REVIEWED:
    //       i.status = "Reviewed";
    //       break;
    //     case EVENT_STATUS_SENT_BACK_FOR_REVIEW:
    //       i.status = "Sent back for review";
    //       break;
    //     default:
    //       break;
    //   }

      let xl_object = {
        "Date of upload": moment(i.event_createdAt).format("DD-MMM-YYYY hh:mm"),
        "Adverse Events": i.adverse_event_name,
        "Serious Adverse Criteria": i.serious_adverse_event_name,
        "Subject ID": i.dose,
        "Site Name": i.subject_code,
        "Status": i.status,
      };
      excelArray.push(xl_object);
    });
    const data = excelArray;
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Qr_subjects_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const handleSearchData = (event) => {
    const searchText = event.target.value.toLowerCase();
    setSearchText(searchText);
    const filteredData = qrSubjectList?.filter((item) => {
      const { subject_code } = item;

      const formattedSubjectCode = subject_code.toLowerCase();


      return (
        formattedSubjectCode.includes(searchText)
      );
    });

    setFilteredData(filteredData);
  };
    return (
        <div>
            <NavigationBar 
            // studyDropdwn={studyDropdwn}
             title={'Sent back for review'}   />
            {/* <PIFlowLeftNavBar /> */}
            <div className='main_body '>
           
            {currentPage === 1 && (
          <Container fluid className="py-4 ">
            {qrSubjectList && qrSubjectList?.length > 0 ? (
              <Container fluid className="pitable_container mt-5  ">
                <Row className='searchbar'>
                  <Col className='searchFiled gap-3'>
                    <label htmlFor="" />
                    <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID' onChange={handleSearchData} />
                    <div className=" ">
                      <button
                        className="white_btn "
                        onClick={exportToExcel}
                      >
                        Download XLS
                      </button>
                    </div>

                  </Col>
                </Row>
                <div className="table-scroll-container">
                  {filteredData?.length > 0 ?
                    <Table bordered size="sm" className="pitable">
                      <thead>
                        <tr>
                          <th> S.No</th>
                          <th>
                            Date of upload
                            <img src="./images/icons/icon_sort.svg" alt="" />
                          </th>
                          <th style={{ minWidth: "145px" }}>
                            Adverse Events
                            <img src="./images/icons/icon_sort.svg" alt="" />
                          </th>
                          <th>
                            Serious Adverse Criteria
                            <img src="./images/icons/icon_sort.svg" alt="" />
                          </th>
                          <th style={{ minWidth: "70px" }}>
                            Subject ID
                            <img src="./images/icons/icon_sort.svg" alt="" />
                          </th>
                          <th style={{ minWidth: "70px" }}>
                            Site Name
                            <img src="./images/icons/icon_sort.svg" alt="" />
                          </th>
                          {/* <th style={{minWidth:"90px"}}>Location
                                        <img src="./images/icons/icon_sort.svg" alt="" />
                                    </th> */}

                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody className="tableBodyScroll">
                        {filteredData?.map((i, index) => {
                          return (
                            <tr key={i.index}>
                              <td> {index + 1} </td>
                              <td>{i.event_createdAt ? i.event_createdAt : "-"}</td>
                              <td>{i.adverse_event_name ? i.adverse_event_name : "-"}</td>
                              <td>{i.serious_adverse_event_name ? i.serious_adverse_event_name : "-"}</td>
                              <td>{i.subject_code ? i.subject_code : "-"}</td>
                              <td>{i.site_name ? i.site_name : "-"}</td>

                              <td className="viewbtnstyl">
                                {/* {i.status ===
                                  EVENT_STATUS_WAITING_FOR_REVIEW && (
                                    <button
                                      className="gray_btn"
                                      onClick={() => handleSubjectData(i)}
                                    >
                                      Waiting for review
                                    </button>
                                  )}
                                {i.status === EVENT_STATUS_IN_PROGRESS && (
                                  <button
                                    className="orange_btn px-3"
                                    onClick={() => handleSubjectData(i)}
                                  >
                                    In progress
                                  </button>
                                )}
                                {i.status === EVENT_STATUS_REVIEWED && (
                                  <button
                                    className="green_btn px-3"
                                    onClick={() => handleSubjectData(i)}
                                  >
                                    Reviewed
                                  </button>
                                )}
                                {i.status ===
                                  EVENT_STATUS_SENT_BACK_FOR_REVIEW && (
                                    <button
                                      className="red_btn"

                                    >
                                      Sent Back For Review
                                    </button>
                                  )} */}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    :
                    <div className="bg-white border py-4">No records found with search criteria</div>

                  }
                </div>
              </Container>
            ) : (
              <>
                <img
                  className="mt-5"
                  src="./images/icons/no_events.svg"
                  alt="Telephone"
                />
                <h5> No events found</h5>
              </>
            )}
          </Container>
        )}

            </div>
            
        </div>
    );
};

export default ReviewRejectedEvents;